import { ModalDisplay } from '../types/paymentsInterstitialModal';
import { events } from '../tracking/events';
import TrackRender from '../tracking/TrackRender';
import ModalDisplayToComponentMap, { getIsCrmModal } from './Modals';
import useTriggerModal from '../hooks/useTriggerModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PAYMENTS_INTERSTITIAL_MODAL_TEST_ID = 'payments-interstitial-modal';
const TWENTY_FOUR_HOURS_MS = 8.64e7;
const PaymentsInterstitialModal = ({
  display,
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleClose = () => {},
  screen,
  subscreen,
  appName,
  toolStatus
}) => {
  const handleInterstitialModalClose = () => {
    handleClose();
    setIsModalOpen(false);
  };
  const shouldShowModal = isModalOpen && display !== ModalDisplay.NONE;
  useTriggerModal('PAYMENTS_EMBED_POINT_REMINDER', TWENTY_FOUR_HOURS_MS, shouldShowModal);
  if (!shouldShowModal) {
    return null;
  }
  const RenderModal = ModalDisplayToComponentMap[display] || ModalDisplayToComponentMap[ModalDisplay.NONE];
  const OrigRenderModal = RenderModal;
  const FtfRenderModal = RenderModal;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": PAYMENTS_INTERSTITIAL_MODAL_TEST_ID,
    children: [/*#__PURE__*/_jsx(TrackRender, {
      event: events.paymentsInterstitialModalView,
      properties: {
        screen,
        subscreen,
        displayType: display,
        subtype: 'paymentsInterstitialModal',
        toolStatus
      }
    }), getIsCrmModal(display) ? /*#__PURE__*/_jsx(FtfRenderModal, {
      onClose: handleInterstitialModalClose,
      page: screen,
      location: subscreen
    }) : /*#__PURE__*/_jsx(OrigRenderModal, {
      handleInterstitialModalClose: handleInterstitialModalClose,
      screen: screen,
      subscreen: subscreen,
      appName: appName
    })]
  });
};
export default PaymentsInterstitialModal;